$('.video-button').click(function () {
    const __dataId = this.dataset.id;
    const __className = `.video-${__dataId}`;
    $(this).toggleClass('video-active');
    playVideo(__className);
    
})

function playVideo ( __name) {
    $(__name).each(function (index,video ) {
        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
    })
}

function initSlideshowSwiper (params) {
    let swiper = new Swiper(params.id, {
        spaceBetween: 30,
        speed: params.speed || 1000,
        centeredSlides: true,
        autoHeight: true,
        loop: params.loop,
        autoplay:params.autoplay,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    return swiper
}